var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {callApi} from "../api";
import {profileHeaderToken} from "../utils";
import {notification} from "antd";
export function createStripeConnectAccount() {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/account/expert/connect/`, {method: "POST"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getExpertsPayouts(token) {
  return __async(this, null, function* () {
    var _a, _b;
    const params = {method: "GET"};
    if (token)
      params["headers"] = profileHeaderToken(token);
    const r = yield callApi(`/account/expert/payouts/`, params);
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function toggleFavoriteExpert(expertPageId) {
  return __async(this, null, function* () {
    var _a, _b;
    const response = yield callApi(`/experts/${expertPageId}/toggle-favorite`, {
      method: "POST"
    });
    if (response.ok) {
      const {isFavorite} = response.payload.data;
      notification.success({message: isFavorite ? "Added To Favorites" : "Removed From Favorites"});
      return response.payload.data.isFavorite;
    } else {
      notification.error({message: `An error occurred: ${(_b = (_a = response.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message}`});
    }
  });
}
